import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  replacementUnavailableFromModel,
  validateReplacementUnavailableCondition,
  type ReplacementUnavailableState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const REPLACEMENT_UNAVAILABLE = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<ReplacementUnavailableState>
  >,
): ConditionType<
  ReplacementUnavailableState,
  Condition.ReplacementUnavailable
> => ({
  name: CONDITION_NAMES[Condition.REPLACEMENT_UNAVAILABLE],
  description() {
    return t(
      "A same-item replacement was offered, but the item was out of stock or no longer exists, so the shopper could not receive one",
    );
  },
  Details(props: ConditionTypeDetailsProps<ReplacementUnavailableState>) {
    return React.createElement(Details, props);
  },
  empty: {},
  fromModel(model) {
    return replacementUnavailableFromModel(model);
  },
  toModel() {
    return { type: Condition.REPLACEMENT_UNAVAILABLE };
  },
  valid(state) {
    return validateReplacementUnavailableCondition(state).valid;
  },
});
